<template>
  <!-- ************************************************** --
    -- ソートダイアログ
    -- ************************************************** -->
  <!-- 受注チップ -->
  <!-- <modal name="order-sort-dialog" class="modalZIndex" :draggable="true" :resizable="false" width="450" :maxWidth="450" height="270" :maxHeight="270" :reset="true" :clickToClose="false"> -->
  <v-dialog v-model="showDialog" height="80%" width="450" max-width="90%" style="z-index:500" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="1" color="#6091d3" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>受注情報並び替え</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onClickOrderSortClose" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row no-gutters align-content="center" class="my-1">
            <div class="px-1 ml-7" style="font-weight:bold;color:navy">入力後[OK]押下で反映されます。</div>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols=1 />
            <v-col :cols=5>
              <dd-drop-down
                label="第１キー"
                placeholder="選択してください"
                v-model="orderSortArgs.orderSortKeyValue1"
                :items="orderSortList"/>
            </v-col>
            <v-col :cols=1 />
            <v-col :cols=5>
              <v-radio-group v-model="orderSortArgs.orderSortKey1" row>
                <dd-radio-button label="昇順" value="asc" />
                <dd-radio-button label="降順" value="desc" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols=1 />
            <v-col :cols=5>
              <dd-drop-down
                label="第２キー"
                placeholder="選択してください"
                v-model="orderSortArgs.orderSortKeyValue2"
                :items="orderSortList"/>
            </v-col>
            <v-col :cols=1 />
            <v-col :cols=5>
              <v-radio-group v-model="orderSortArgs.orderSortKey2" row>
                <dd-radio-button label="昇順" value="asc" />
                <dd-radio-button label="降順" value="desc" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols=1 />
            <v-col :cols=5>
              <dd-drop-down
                label="第３キー"
                placeholder="選択してください"
                v-model="orderSortArgs.orderSortKeyValue3"
                :items="orderSortList"/>
            </v-col>
            <v-col :cols=1 />
            <v-col :cols=5>
              <v-radio-group v-model="orderSortArgs.orderSortKey3" row>
                <dd-radio-button label="昇順" value="asc" />
                <dd-radio-button label="降順" value="desc" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickOrderSortClose">閉じる</v-btn>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickOrderSortClear">クリア</v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickOrderSortExec">ＯＫ</v-btn>
      </v-card-actions>
    </v-card>
  <!-- </modal> -->
  </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//
// DdComponents アルファベット順記述
// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
// import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'

// vue Definition
// import { mapGetters } from 'vuex'

const DdDropDown = () => import('@/components/DdDropDown')
const DdRadioButton = () => import('@/components/DdRadioButton')

export default {
  name: 'DdHaishaOrderSortDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    // DdCheckbox,
    // DdCodeTextBox,
    // DdDataTable,
    // DdDateBox,
    // DdDefaultButton,
    DdDropDown,
    // DdFooterButton,
    // DdIconButtonWithTooltip,
    // DdNumericBox,
    DdRadioButton
    // DdSimpleTable,
    // DdSubHeader,
    // DdSubTitle,
    // DdSwitch,
    // DdTextArea,
    // DdTextBox,
    // DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: {
      orderSortKey1: 'asc',
      orderSortKey2: 'asc',
      orderSortKey3: 'asc',
      orderSortKeyValue1: '',
      orderSortKeyValue2: '',
      orderSortKeyValue3: ''
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,

    // 受注ソート初期値
    orderSortArgs: {
      orderSortKey1: 'asc',
      orderSortKey2: 'asc',
      orderSortKey3: 'asc',
      orderSortKeyValue1: '',
      orderSortKeyValue2: '',
      orderSortKeyValue3: ''
    },
    orderSortList: [
      { value: 'ninushiCd', text: '取引先コード' },
      { value: 'ninushiNm', text: '取引先名称' },
      { value: 'hatsuchiCd', text: '積地コード' },
      { value: 'hatsuchiNm', text: '積地名称' },
      { value: 'hatsuchiHms', text: '積時刻' },
      { value: 'chakuchiCd', text: '卸地コード' },
      { value: 'chakuchiNm', text: '卸地名称' },
      { value: 'chakuchiHms', text: '卸時刻' }
    ],

    // 戻り値用定義
    rec: {
      id: 0
    }
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        this.orderSortArgs = Object.assign({}, this.param)
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      // const opt = {
      //   loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu']
      // }
      // this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rec.chipColor = '#00FF00'
      this.chipColorTmp = this.rec.chipColor
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickOrderSortClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickOrderSortExec: function (e) {
      console.log(this.param)
      console.log(this.orderSortArgs)
      this.$emit('exec', this.orderSortArgs)
    },
    // --------------------------------------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------------------------------------
    onClickOrderSortClear: function () {
      Object.assign(this.orderSortArgs, this.$options.data().orderSortArgs)
      this.$emit('exec', this.orderSortArgs)
    }
  }
}
</script>
<style></style>
